module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phone":"Phone"},"fr":{"phone":"Téléphone"}}')
  delete Component.options._Ctor
}
